const MS_IN_SEC = 1000;

export const getFormatDate = (isShort?: boolean) => (timestamp: number) => {
  const date = new Date(timestamp * MS_IN_SEC).toLocaleDateString();
  return isShort ? date.substring(3) : date;
};
